import { GatewayChargingSessionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/charging-sessions/gateway-charging-session.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoChargingSessionListStatusCell } from './emsp-bo-charging-session-list-status.cell';
import { EmspBoChargingSessionListStatusHeader } from './emsp-bo-charging-session-list-status.header';

export const EmspBoChargingSessionListStatusColumn: IdentifiedColumnDef<
  GatewayChargingSessionModel,
  GatewayChargingSessionModel['status']
> = {
  enableSorting: false,
  header: EmspBoChargingSessionListStatusHeader,
  cell: EmspBoChargingSessionListStatusCell,
  meta: { maxWidth: '150px', width: '130px', minWidth: '80px' },
};
